import { useEffect, useLayoutEffect } from 'react';

/**
 * A `useLayoutEffect` that won't warn during SSR.
 *
 * - Browser: `useLayoutEffect` (runs before paint)
 * - Server: `useEffect` (avoids SSR warning)
 */
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
